import { useState, useEffect } from "react";
import Iframe from 'react-iframe'
import { useSelector } from 'react-redux'
import blue_check from "../../../../assets/images/blue_check.svg";
import './TorLink.scss'

const TorLink = (props) => {
    const {data} =useSelector((state)=>state.data)
    const { FirstName } = useSelector((state) => state.auth);

  return (
    <div className="tor_link">
      <div className="iframe-hello">
        <img src={blue_check} alt="blue_check" />
        <div className="iframe-hello" style={{'display':'block'}}>
          <div style={{'font-weight':'lighter'}}>שלום {FirstName},</div>
          <div style={{'font-weight':'bolder'}}>
            אנחנו שמחים להודיעך כי הרכב מוכן. ניתן לתאם מסירה על ידי בחירת תאריך ושעה
          </div>
        </div>  
      </div>
      <Iframe url={`${data?.torLink}&output=embed`}
        width="100%"
        height="450px"
      />
    </div>
    
  )
}

export default TorLink
